import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .margin-view-overlays .cmdr{height:100%;left:0;position:absolute;width:100%}";
n(css,{});
export { css, css as default };
